import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Box from 'core/components/Box';
import Button from 'core/components/Button';
import Flex from 'core/components/Flex';
import Text from 'core/components/Text';

const VALID_HEADER_NAME = /^[a-zA-Z][a-zA-Z0-9._-]*$/;

@observer
export default class CustomHeadersEditor extends Component {
  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    value: [],
    disabled: false
  };

  get headers() {
    const { value } = this.props;
    return Array.isArray(value) && value.length > 0 ? value : [{ key: '', value: '' }];
  }

  handleKeyChange = (index, newKey) => {
    const { onChange } = this.props;
    const updated = this.headers.map((item, i) => (i === index ? { ...item, key: newKey } : item));

    onChange(updated);
  };

  handleValueChange = (index, newValue) => {
    const { onChange } = this.props;
    const updated = this.headers.map((item, i) => (i === index ? { ...item, value: newValue } : item));

    onChange(updated);
  };

  handleAdd = () => {
    const { onChange } = this.props;

    onChange([...this.headers, { key: '', value: '' }]);
  };

  handleRemove = (index) => {
    const { onChange } = this.props;
    const filtered = this.headers.filter((_, i) => i !== index);

    onChange(filtered.length > 0 ? filtered : [{ key: '', value: '' }]);
  };

  render() {
    const { disabled } = this.props;
    const { headers } = this;

    return (
      <Box>
        <Flex mb="4px">
          <Box flex={1} mr={1}>
            <Text small muted>
              Name
            </Text>
          </Box>
          <Box flex={1} mr={1}>
            <Text small muted>
              Value
            </Text>
          </Box>
          <Box width={30} />
        </Flex>

        {headers.map((item, index) => {
          const keyInvalid = item.key && !VALID_HEADER_NAME.test(item.key);
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Flex key={index} mb="6px" alignItems="center">
              <Box flex={1} mr={1}>
                <input
                  className={`bp4-input bp4-fill${keyInvalid ? ' bp4-intent-danger' : ''}`}
                  placeholder="Header name"
                  value={item.key || ''}
                  onChange={(e) => this.handleKeyChange(index, e.target.value)}
                  disabled={disabled}
                />
              </Box>
              <Box flex={1} mr={1}>
                <input
                  className="bp4-input bp4-fill"
                  placeholder="Header value"
                  value={item.value || ''}
                  onChange={(e) => this.handleValueChange(index, e.target.value)}
                  disabled={disabled}
                />
              </Box>
              <Button
                icon="trash"
                intent="danger"
                minimal
                onClick={() => this.handleRemove(index)}
                disabled={disabled}
              />
            </Flex>
          );
        })}

        <Button icon="plus" minimal intent="primary" onClick={this.handleAdd} disabled={disabled}>
          Add Header
        </Button>
      </Box>
    );
  }
}
